import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { patientNotesGetAction } from "../../actions/patientAction";
import ConfirmDialog from "../../components/ConfirmDialog";
import FormikControl from "../../components/WraapperComponent/FormikControl";

const AddNoteForm = ({
  note,
  patientId,
  hideFormAction,
  formRef,
  noteId = 0,
  setCanshowpopup,
}) => {
  const dispatch = useDispatch();

  const initialValues = {
    note: note,
  };

  const validationSchema = Yup.object({
    note: Yup.string().nullable().required("Required"),
  });

  const handleOnBlur = () => {
    setCanshowpopup(true);
  };

  const onSubmit = (values) => {
    setCanshowpopup(false);
    let noteIdValue = noteId === 0 ? "" : noteId;
    let actionName = noteId === 0 ? "addPatientNotes" : "editPatientNotes";
    dispatch(
      patientNotesGetAction(
        actionName,
        patientId,
        noteIdValue,
        values.note,
        () => {
          dispatch(patientNotesGetAction("getPatientNotes", patientId));
        }
      )
    );

    hideFormAction();
  };
  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ errors, touched }) => {
          return (
            <Form>
              <div className="row">
                <div className="col-sm-12">
                  <FormikControl
                    control="textarea"
                    label="Note: "
                    name="note"
                    rows="4"
                    placeholder="Enter Feedback about your prescription here"
                    hasError={errors.note && touched.note}
                    onBlur={handleOnBlur}
                  />
                </div>

                <button style={{ opacity: 0 }} ref={formRef} type="submit" />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};
export default AddNoteForm;
